import React from 'react';
import moment from 'moment';
import { TRANSACTIONS_COLUMNS } from '../../../../utils/constants/transactions-columns';
import { TRANSACTIONS_STATUSES } from '../../../../utils/constants/transactions-statuses';
import TransactionsTable from '../tables/TransactionsTable';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import { PartnerGuard } from '../../../../guards/RolesGuard';


interface ITransactionsDetailsModal {
    openModal: boolean;
    transactionDetails?: any;
    handleCloseModal: () => void;
    onOpenReview: (transaction: any) => void;
}

const TransactionsDetailsModal = ({
    openModal,
    transactionDetails,
    handleCloseModal,
    onOpenReview
}: ITransactionsDetailsModal) => {


    const onCloseModal = () => {
        handleCloseModal();
    };

    const formatStatus = (status: string) => {
        if (status !== 'voided transaction') {
            const findTransactionStatus = TRANSACTIONS_STATUSES?.find((item: any) => item?.value === status)

            return <div className={`flex items-center px-3 py-1 ${findTransactionStatus?.statusColor} rounded-full justify-center`}>
                <p className={`${findTransactionStatus?.color} font-normal text-nowrap`}>{findTransactionStatus?.name}</p>
            </div>
        } else {
            return <div className={`flex items-center px-3 py-1 bg-[#545863] rounded-md justify-center`}>
                <p className={`text-white font-normal text-nowrap`}>Voided</p>
            </div>
        }
    }

    const formatText = (text: string | null | undefined): string => {
        if (!text) return '';

        return text
            .toLowerCase()
            .split(' ')
            .map(word =>
                word.charAt(0).toUpperCase() + word.slice(1)
            )
            .join(' ');
    };

    const getColorAndIcon = (color: string) => {
        switch (color) {
            case 'Green':
            case 'green':
                return { color: 'text-[#10B981]', icon: '/assets/insights-tab/matched-table.svg' }
            case 'Red':
            case 'red':
                return { color: 'text-[#EF4444]', icon: '/assets/insights-tab/discrepancy-table.svg' }
            case 'Amber':
            case 'amber':
                return { color: 'text-[#F59E0B]', icon: '/assets/insights-tab/likely-matched-table.svg' }
            case 'Blue':
            case 'blue':
                return { color: 'text-[#2D8EFF]', icon: '/assets/insights-tab/likely-matched-table.svg' }
        }
    }

    return (
        <Modal
            open={openModal}
            title='Transaction Details'
            headerStyle='border-b-1 py-3 mb-0'
            onClose={onCloseModal}
            contentContainerStyle='!rounded-xl min-w-[95%] md:min-w-[85%] lg:min-w-[85%]'>
            <div className='p-2 min-w-[95%] md:min-w-[80%] lg:min-w-[80%] min-h-[400px]'>
                <div className='my-5'>
                    {TRANSACTIONS_COLUMNS?.map((item: any, idx: number) => {
                        let detailsForKey: any = <p>{transactionDetails?.[item?.key] || '--'}</p>
                        if (item?.key === 'reason') {
                            detailsForKey = <div>{formatText(transactionDetails?.[item?.key])}</div>
                        }
                        if (item?.key === 'variance') {
                            detailsForKey = <div className={`${getColorAndIcon(transactionDetails?.rag)?.color}`}>€{transactionDetails?.[item?.key] || 0}</div>
                        }
                        if (item?.key === 'status') {
                            detailsForKey = <div>{formatStatus(transactionDetails?.[item?.key])}</div>
                        }
                        if (item?.key === 'amountPOS' || item?.key === 'amountPSP') {
                            detailsForKey = <div className='text-right'>
                                <p>{['amountPOS', 'amountPSP']?.includes(item?.key) ? '€' : ''}{Number(transactionDetails?.[item.key] || 0).toFixed(2)}</p>
                                {/* <p className='text-primary-light text-sm'>{transactionDetails?.[item?.secondKey] ? moment(transactionDetails?.[item?.secondKey]).format('DD/MM/YYYY hh:mm A') : ''}</p> */}
                            </div>
                        }
                        if (item?.key === 'pspDateTime' || item?.key === 'posDateTime') {
                            return (
                                <td key={idx} className={`px-4 py-4 min-w-[120px]`}>
                                    <p className='text-sm'>{transactionDetails?.[item?.key] ? moment(transactionDetails?.[item?.key]).format('DD/MM/YYYY hh:mm A') : '--'}</p>
                                </td>
                            )
                        }
                        return (
                            <div key={idx} className='flex flex-row justify-between items-start py-3 px-2 border-b border-b-1 dark:text-primary-dark'>
                                <p>{item?.name}</p>
                                {detailsForKey}
                            </div>
                        )
                    })}
                </div>
                {(transactionDetails?.multipleReferenceMatches?.length > 0 || transactionDetails?.voidedMatches?.length > 0) &&
                    <div className='my-5'>
                        <TransactionsTable
                            rows={transactionDetails?.status !== 'voided transaction' ? transactionDetails?.multipleReferenceMatches : transactionDetails?.voidedMatches}
                            columns={TRANSACTIONS_COLUMNS}
                            hideActions={true}
                        />
                    </div>
                }
                {((transactionDetails?.multipleReferenceMatches?.length > 0 || transactionDetails?.voidedMatches?.length > 0) && PartnerGuard()) &&
                    <div className='flex flex-row justify-end my-5'>
                        <Button
                            className={`btn-main dark:bg-black dark:text-primary-dark !shadow-none min-w-[150px] !rounded `}
                            label={'Review'}
                            dataQa={'submit-btn'}
                            onClickButton={() => onOpenReview(transactionDetails)}
                        />
                    </div>
                }
            </div>
        </Modal>
    );
};

export default TransactionsDetailsModal;